/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TradePlanDetailType = {
    TRADE: 'trade',
    BUY_DEBUG: 'buy_debug',
    SELL_DEBUG: 'sell_debug',
    PORTFOLIO_CONFIG: 'portfolio_config',
    UNIVERSE: 'universe',
    PREFERENCES: 'preferences',
    TRADE_INPUT: 'trade_input',
    DETAILS: 'details',
    TRADABLE_LOTS: 'tradable_lots',
    CUSTOM_ASSET_DEBUG: 'custom_asset_debug',
    RESTRICTION_DETAIL: 'restriction_detail',
    BUY_CONSTRAINT_DEBUG: 'buy_constraint_debug',
    SELL_CONSTRAINT_OPEN_LOT: 'sell_constraint_open_lot',
    SELL_CONSTRAINT_CLOSED_LOT: 'sell_constraint_closed_lot',
    REPLACEMENT_SOLVER_DEBUG: 'replacement_solver_debug',
    TRADE_QUANTITY_DETAIL: 'trade_quantity_detail',
    PORTFOLIO: 'portfolio',
    POSITION: 'position',
    PV: 'pv',
    CASHFLOW: 'cashflow',
    PAYDAY_PNL_IMPACT: 'payday_pnl_impact',
    CONVICTION_DEBUG: 'conviction_debug',
    CONVICTION_PNL_IMPACT: 'conviction_pnl_impact',
    CASH_ALLOCATION: 'cash_allocation',
    SECURED_ALLOCATION: 'secured_allocation',
    CONVICTION_ALLOCATION: 'conviction_allocation',
    GROWTH_ALLOCATION: 'growth_allocation',
    EXCLUDED_ALLOCATION: 'excluded_allocation',
    ACCOUNT_CONSTRAINT: 'account_constraint',
    ACCOUNT_GROWTH_ALLOCATION_INPUT: 'account_growth_allocation_input',
    PORTFOLIO_GROWTH_ALLOCATION_INPUT: 'portfolio_growth_allocation_input',
    ACCOUNT_CONFIGURATION_INPUT: 'account_configuration_input',
    RESTRICTION_INPUT: 'restriction_input'
} as const;
export type TradePlanDetailType = typeof TradePlanDetailType[keyof typeof TradePlanDetailType];


export function instanceOfTradePlanDetailType(value: any): boolean {
    for (const key in TradePlanDetailType) {
        if (Object.prototype.hasOwnProperty.call(TradePlanDetailType, key)) {
            if (TradePlanDetailType[key as keyof typeof TradePlanDetailType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TradePlanDetailTypeFromJSON(json: any): TradePlanDetailType {
    return TradePlanDetailTypeFromJSONTyped(json, false);
}

export function TradePlanDetailTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradePlanDetailType {
    return json as TradePlanDetailType;
}

export function TradePlanDetailTypeToJSON(value?: TradePlanDetailType | null): any {
    return value as any;
}

export function TradePlanDetailTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TradePlanDetailType {
    return value as TradePlanDetailType;
}

